<template>
	<footer class="content-footer">
		<div class="company-info">
			<div class="logo pl-6">
				<img :src="require('../../assets/images/icon/logo@2x-navy.png')" />
			</div>
			<div class="adr">
				<nav-link :url="'https://www.okta.net/site/okta/page/member/privacy/'" target="_blank">개인정보처리방침</nav-link>
				<div>
					<span class="company-mobile">상호명 : (사)세계한인무역협회</span>
					<span class="company-mobile">대표 : 장영식</span>
					<span class="company-mobile" style="margin-bottom: 0px">사업자번호 : 120-82-04795</span>
					<p class="company-web company-pad">상호명 : (사)세계한인무역협회 / 대표 : 장영식 / 사업자번호 : 120-82-04795</p>
					<br />
					<p class="adr-web">본부사무국 : (07548)서울특별시 강서구 화곡로 416 더스카이밸리 5차 지식산업센터 11층 1129호</p>
					<pre class="adr-pad">본부사무국 : (07548)서울특별시 강서구 화곡로 416 더스카이밸리 5차 <br />          지식산업센터 11층 1129호 </pre>

					<p class="footer-tel ml-1">
						TEL : <nav-link :url="'tel:031-927-9218'" external-url>031-927-9218</nav-link> / EMAIL :
						<nav-link :url="'mailto:info@okta.net'" external-url>info@okta.net</nav-link>
					</p>
					<br />
					<p class="footer-marketing">
						마케팅지원팀 : <nav-link :url="'tel:02-571-5220'" external-url>02-571-5220</nav-link> /
						<nav-link :url="'hello@okta.net'" external-url>hello@okta.net</nav-link>
					</p>
				</div>
			</div>
		</div>
		<div class="copyright">COPYRIGHT © World-OKTA ALL RIGHTS RESERVED.</div>
	</footer>
</template>

<script>
export default {
	name: 'Footer',
};
</script>

<style scoped></style>
